export default {
    flag: 'flag',
    rule: 'rule'
};
